
import {isEmpty} from 'lodash';

import {getTacticalConfigColumnsForRecommStatus} from './grid-recommendation-tactical-utils.js';
import {CHART_NAME} from '../../../../utils/constants.js';
import {RECOMMENDATION_STATUS_KEYS, generateDatesBetween, getFromToDate} from '../charts-util.js';

export const getCompetitiveChangesFareChartTacticalConfig = (recommendationStatus, reasonsDropdownData, datesInSequence, filterBy, percentAbsolute, posOnClickHandler) => {
    const isAnalystStatusView = RECOMMENDATION_STATUS_KEYS.APPROVAL_STATUS === recommendationStatus;

    return {
        chartKey: `${CHART_NAME.CHART_TACTICAL}-${CHART_NAME.CHART_COMPETITIVE_CHANGE_FARE}-${recommendationStatus}`,
        tableClassName: `competitive-changes-fare-tactical${isAnalystStatusView ? ' approval-status-view' : ''}`,
        isVerticalHeader: !isAnalystStatusView,
        configTree: {
            isSubRows: true,
            childKey: 'subRows'
        },
        configColumns: getTacticalConfigColumnsForRecommStatus(recommendationStatus, reasonsDropdownData, isEmpty(filterBy) ? datesInSequence : generateDatesBetween(getFromToDate(filterBy), true), percentAbsolute, posOnClickHandler),
        cssClasses: {
            tooltipCss: `competitive-changes-fare-tactical-tooltip${isAnalystStatusView ? ' approval-status-view-tooltip' : ''}`
        }
    };
};
